// Entry point for the build script in your package.json
import * as bootstrap from "bootstrap";
import "@hotwired/turbo-rails"
import "./controllers"

document.addEventListener("turbo:load", () => {
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => new bootstrap.Tooltip(el))
})
